export default {
  'FLIGHT_BLOCK' (state) {
    return state.flightBlock
  },
  'FLIGHT_BLOCKS' (state) {
    return state.flightBlocks
  }
}
